import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_GET_NON_NATIONAL_EXAM_CONFIRM_AND_PAY_DATA} from '../../constants/apiUrls';
import {NonNationalConfirmAndPayResponse} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: NonNationalConfirmAndPayResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGetConfirmAndPayData = ({onSuccess, onError}: Input) => {
  const postGetConfirmAndPayData = async (payload: { uuid: string }) => {
    const res = await axiosClient.post<NonNationalConfirmAndPayResponse>(
        POST_GET_NON_NATIONAL_EXAM_CONFIRM_AND_PAY_DATA(payload.uuid)
    );
    return res.data;
  };

  return useCustomMutation(postGetConfirmAndPayData, {
    onSuccess,
    onError,
  });
};
